import { enqueueSnackbar } from 'notistack';
import {
  handleDisplayError,
  matchResponse,
  ResponseHandler,
} from './api-error-handler.utils';
import { Middleware } from '@reduxjs/toolkit';

// This list is ordered by priority (first match wins). A response can match multiple handlers,
// so make sure the most specific ones are at the top.
const responseHandlers: ResponseHandler[] = [
  {
    match: { status: 401, isRejected: true },
    then: 'ignore',
  },
  {
    match: { endpointName: 'getClientDomain', isRejected: true },
    then: 'ignore',
  },
  {
    match: { incentivioCode: 'LOYALTY_REPORT_TIMEOUT', isRejected: true },
    then: action => {
      return enqueueSnackbar(
        action.meta.baseQueryMeta?.response?.headers?.get('incentivio-message'),
        { severity: 'warning' },
      );
    },
  },
  {
    match: { incentivioCode: 'ORDER_REPORT_TIMEOUT', isRejected: true },
    then: action => {
      return enqueueSnackbar(
        action.meta.baseQueryMeta?.response?.headers?.get('incentivio-message'),
        { severity: 'warning' },
      );
    },
  },
  {
    match: { isRejected: true },
    then: action => handleDisplayError(action),
  },
];

export const rtkQueryErrorHandler: Middleware = _api => next => action => {
  const responseHandler = matchResponse(action, responseHandlers);
  if (typeof responseHandler?.then === 'function') {
    responseHandler.then(action);
  }

  return next(action);
};
